import { useMantineColorScheme } from "@mantine/core"
import dayjs from "dayjs"
import { useSystemColors } from "@components/use-system-colors"

export function useBackgroundColorForDate(date: Date, isHoliday?: boolean) {
  const { colorScheme } = useMantineColorScheme()

  const { data: systemColors } = useSystemColors()

  if (colorScheme === "dark") {
    return dayjs(date).isToday()
      ? systemColors?.TodayBackColorDark
      : isHoliday
        ? systemColors?.SchoolHolidaysBackColorDark
        : date.getDay() === 6
          ? systemColors?.SaturdayBackColorDark
          : date.getDay() === 0
            ? systemColors?.SundayBackColorDark
            : undefined
  }

  return dayjs(date).isToday()
    ? systemColors?.TodayBackColor
    : isHoliday
      ? systemColors?.SchoolHolidaysBackColor
      : date.getDay() === 6
        ? systemColors?.Saturday
        : date.getDay() === 0
          ? systemColors?.Sunday
          : undefined
}

export function useSchoolHolidayColor() {
  const { colorScheme } = useMantineColorScheme()

  const { data: systemColors } = useSystemColors()

  return colorScheme === "dark"
    ? systemColors?.HolidayBackColorDark
    : systemColors?.Holiday
}
